export default __webpack_public_path__ + "f68d5f02b1851aa68a81c638e65ad708.png";